import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonCard = ({ fill }) => {
  fill = fill ? fill : 4;
  return (
    <ul className="skeletoncontainer">
      {Array(fill)
        .fill()
        .map((item, index) => (
          <li className="skeletoncard" key={index}>
            <div className="skeletoninfo">
              <Skeleton height={148} width={265} />
              <div className="cardItems">
                <span>
                  <Skeleton width={80} height={16} />
                  <Skeleton width={230} height={16} />
                  <Skeleton width={230} height={12} />
                </span>
                <span className="skeleton-event-date">
                  <Skeleton width={175} height={12} />
                </span>
              </div>
            </div>
          </li>
        ))}
    </ul>
  );
};

export default SkeletonCard;
